/** Chat, party, clan, friends, quests, ranking, travel, game menu, sign-in and server screens. */
export default {
  // Chat
  Global: "Genel",
  "Say something to everyone": "Herkese bir şey söyle",
  "Say something to your party": "Partine bir şey söyle",
  "Say something to your clan": "Klanına bir şey söyle",
  "[Party]": "[Parti]",
  "[Clan]": "[Klan]",
  // Owner decision (2026-10-01): the kill line reads the same in both languages.
  "{killer} defeat {victim}": "{killer} defeat {victim}",
  "Tap Chat to talk. /help lists the commands.":
    "Konuşmak için Sohbet'e dokun. /help komutları listeler.",
  "Press Enter to chat. /help lists the commands.":
    "Sohbet için Enter'a bas. /help komutları listeler.",
  "Unknown command {cmd}. Try /help": "Bilinmeyen komut {cmd}. /help yazmayı dene",
  "Nobody has whispered to you yet": "Henüz kimse sana fısıldamadı",
  "{name} is blocked": "{name} engellendi",
  "{name} is unblocked": "{name} engeli kaldırıldı",
  "Blocked: {list}": "Engellenenler: {list}",
  "Nobody is blocked. /block Name": "Kimse engelli değil. /block İsim",
  "Usage: /w Name message": "Kullanım: /w İsim mesaj",
  "To {name}:": "{name} kişisine:",
  "{name} whispers:": "{name} fısıldıyor:",

  // Party
  "You lead this party": "Bu partinin lideri sensin",
  Party: "Parti",
  Leave: "Ayrıl",
  "Party leader": "Parti lideri",
  "Lv {n}": "Sv. {n}",
  "Lv {n}+": "Sv. {n}+",
  "Remove from party": "Partiden çıkar",
  Offline: "Çevrimdışı",
  Online: "Çevrimiçi",
  Dead: "Ölü",
  "{name} invites you to their party.": "{name} seni partisine davet ediyor.",
  "{name} invites you to the clan {clan}.": "{name} seni {clan} klanına davet ediyor.",
  Decline: "Reddet",
  Accept: "Kabul et",

  // Clan
  Leader: "Lider",
  Officer: "Subay",
  Member: "Üye",
  Clan: "Klan",
  "You are not in a clan": "Bir klanda değilsin",
  "Found a clan of up to {n} players of your nation, or ask a clan leader or officer for an invite.":
    "Ulusundan en fazla {n} oyuncunun katılabileceği bir klan kur ya da bir klan liderinden veya subayından davet iste.",
  Level: "Seviye",
  Cost: "Bedel",
  "{n} gold": "{n} altın",
  "Clan name": "Klan adı",
  "Found clan": "Klan kur",
  "Grade {n}": "Derece {n}",
  "{n} to grade {grade}": "{grade}. dereceye {n}",
  "the highest grade": "en yüksek derece",
  "Clan cloaks are open at the Clan Steward in your capital.":
    "Klan pelerinleri başkentindeki Klan Kahyası'nda açık.",
  "Clan cloaks open at grade {grade} (a new clan starts at {lowest}).":
    "Klan pelerinleri {grade}. derecede açılır (yeni bir klan {lowest}. dereceden başlar).",
  "{n} / {max} members, {online} online": "{n} / {max} üye, {online} çevrimiçi",
  "Invite a player by name": "Bir oyuncuyu adıyla davet et",
  "Player name": "Oyuncu adı",
  Invite: "Davet et",
  Name: "İsim",
  Status: "Durum",
  Demote: "Rütbe düşür",
  "Make leader": "Lider yap",
  Lead: "Lider yap",
  Remove: "Çıkar",
  "Click again to disband": "Dağıtmak için tekrar tıkla",
  "Disband clan": "Klanı dağıt",
  "Leave clan": "Klandan ayrıl",

  // Friends
  Friends: "Arkadaşlar",
  "{n} / {max}, {online} online": "{n} / {max}, {online} çevrimiçi",
  "Add a friend by name": "Adıyla arkadaş ekle",
  Add: "Ekle",
  "No friends yet. Add players of your nation by name to see when they are online and where.":
    "Henüz arkadaşın yok. Ne zaman çevrimiçi olduklarını ve nerede olduklarını görmek için ulusundan oyuncuları adıyla ekle.",
  Whisper: "Fısılda",

  // Quests
  "Defeat {n} of the other nation": "Diğer ulustan {n} oyuncu yen",
  "Collect {n} {item} from {mob}": "{mob} canavarından {n} {item} topla",
  "Kill {n} {mob}": "{n} {mob} öldür",
  Quests: "Görevler",
  "Take them and hand them in from here, anywhere": "Her yerden, buradan al ve teslim et",
  Daily: "Günlük",
  "In progress": "Devam eden",
  "Hand in": "Teslim et",
  Drop: "Bırak",
  "No open quests. Take one below.": "Açık görev yok. Aşağıdan bir tane al.",
  Available: "Alınabilir",
  "Log full": "Liste dolu",
  Take: "Al",
  "Nothing new at your level. More opens as you level up.":
    "Seviyende yeni görev yok. Seviye atladıkça yenileri açılır.",
  "Coming up": "Yakında",
  "Done today": "Bugün bitenler",
  "{list}. Daily quests come back at midnight.": "{list}. Günlük görevler gece yarısı yenilenir.",
  "Hand in (Q)": "Teslim et (Q)",

  // Ranking
  "National Points": "Ulusal Puan",
  "Earned by defeating the other nation in the Colony Zone":
    "Koloni Bölgesi'nde diğer ulusu yenerek kazanılır",
  "This month": "Bu ay",
  "All time": "Tüm zamanlar",
  "Loading...": "Yükleniyor...",
  "Could not load the ranking": "Sıralama yüklenemedi",
  "No one has earned National Points yet": "Henüz kimse Ulusal Puan kazanmadı",

  // Travel
  "Open · closes in {min} min · {stay} min stay": "Açık · {min} dk sonra kapanır · {stay} dk kalış",
  "Opens {times} (Istanbul)": "Açılış: {times} (İstanbul)",
  and: "ve",
  "War on · ends in {min} min": "Savaş sürüyor · {min} dk sonra biter",
  "Next war {when}": "Sonraki savaş {when}",
  "No war now": "Şu an savaş yok",
  "Closed during the war": "Savaş sırasında kapalı",
  Travel: "Yolculuk",
  None: "Yok",
  "Requires Lv {n}": "Sv. {n} gerekir",
  "All levels": "Tüm seviyeler",
  "War Keepers": "Savaş Muhafızları",
  "You are Lv {n}": "Sen Sv. {n}",
  Closed: "Kapalı",
  "Travel Gate": "Yolculuk Kapısı",
  "Pick where the gate takes you": "Kapının seni nereye götüreceğini seç",
  "This gate leads nowhere for you.": "Bu kapı seni hiçbir yere götürmüyor.",

  // Game menu
  "Names above heads": "Başların üstünde isimler",
  "Your target's name always shows": "Hedefinin adı her zaman görünür",
  "Damage numbers": "Hasar sayıları",
  "Floating hits, heals and XP": "Uçuşan vuruşlar, iyileşmeler ve XP",
  "FPS counter": "FPS göstergesi",
  "Beside the clock": "Saatin yanında",
  Sound: "Ses",
  "Fights, spells, loot and the interface": "Dövüşler, büyüler, ganimet ve arayüz",
  "World sounds": "Dünya sesleri",
  "Now and then: birds, crickets, campfires, war drums":
    "Arada bir: kuşlar, cırcır böcekleri, kamp ateşleri, savaş davulları",
  High: "Yüksek",
  Medium: "Orta",
  Low: "Düşük",
  Menu: "Menü",
  Ranking: "Sıralama",
  Display: "Görüntü",
  Graphics: "Grafik",
  "Lower is faster on weak devices": "Düşük ayar zayıf cihazlarda daha hızlıdır",
  "Frame rate": "Kare hızı",
  "Lower keeps the computer cooler": "Düşük ayar bilgisayarı daha az ısıtır",
  "Lower keeps the phone cooler": "Düşük ayar telefonu daha az ısıtır",
  Max: "Maks",
  Volume: "Ses seviyesi",
  "All game sounds": "Tüm oyun sesleri",
  "The game reloads in the new language": "Oyun yeni dilde yeniden yüklenir",
  Account: "Hesap",
  "Change character": "Karakter değiştir",
  "Click again to leave": "Çıkmak için tekrar tıkla",
  "Exit game": "Oyundan çık",

  // Home, sign in and servers
  "Humans of Valcrest": "Valcrest İnsanları",
  "Orcs of Gorzhak": "Gorzhak Orkları",
  "Crown of Valcrest": "Valcrest Tacı",
  "Crown of Gorzhak": "Gorzhak Tacı",
  "Play now": "Hemen Oyna",
  "Humans against orcs, and one frontier between them. Choose a side.":
    "İnsanlar orklara karşı, aralarında tek bir sınır. Tarafını seç.",
  "Free in your browser. Create an account and pick your side.":
    "Tarayıcında ücretsiz. Hesap oluştur ve tarafını seç.",
  "Back to the website": "Web sitesine dön",
  "Free to play. Create an account and pick your side.":
    "Ücretsiz oyna. Hesap oluştur ve tarafını seç.",
  "Sign in": "Giriş yap",
  "Create account": "Hesap oluştur",
  Email: "E-posta",
  Password: "Şifre",
  "Repeat password": "Şifre tekrarı",
  "8 to 64 characters": "8-64 karakter",
  "An uppercase letter": "Bir büyük harf",
  "A lowercase letter": "Bir küçük harf",
  "A digit": "Bir rakam",
  "Forgot your password?": "Şifreni mi unuttun?",
  or: "veya",
  "Create your account": "Hesabını oluştur",
  "Welcome back": "Tekrar hoş geldin",
  "One account for all your characters, on any device.":
    "Tüm karakterlerin için tek hesap, her cihazda.",
  "Sign in to play your characters.": "Karakterlerinle oynamak için giriş yap.",
  Full: "Dolu",
  Quiet: "Sakin",
  Busy: "Yoğun",
  Crowded: "Kalabalık",
  "Choose a server": "Bir sunucu seç",
  "Looking for servers...": "Sunucular aranıyor...",
  "Try again": "Tekrar dene",
  "The game servers cannot be reached right now.": "Oyun sunucularına şu an ulaşılamıyor.",
  Servers: "Sunucular",
  Channels: "Kanallar",
  Connect: "Bağlan",
  "More channels open when these get busy (up to {n}).":
    "Bunlar yoğunlaşınca yeni kanallar açılır (en fazla {n}).",
  "Every channel of this server is open.": "Bu sunucunun tüm kanalları açık.",
  Open: "Açık",
  "Full, {n} waiting": "Dolu · {n} kişi bekliyor",
  "The server is full. You are number {n} in line.": "Sunucu dolu. Sıradaki yerin: {n}",
  "You join on your own when a place frees up. Gold Premium accounts go first.":
    "Yer açılınca kendiliğinden bağlanacaksın. Gold Premium hesaplar önceliklidir.",
  "Stop waiting": "Beklemeyi bırak",
  Server: "Sunucu",
  Channel: "Kanal",
  Refresh: "Yenile",

  // Account and sign-in errors
  "Signed in": "Giriş yapıldı",
  "Sign out": "Çıkış yap",
  "Enter your email and password.": "E-posta adresini ve şifreni gir.",
  "Enter a valid email address.": "Geçerli bir e-posta adresi gir.",
  "Passwords need 8 to 64 characters with an uppercase letter, a lowercase letter and a digit.":
    "Şifre 8-64 karakter olmalı ve en az bir büyük harf, bir küçük harf ve bir rakam içermeli.",
  "That password is too easy to guess. Choose another one.":
    "Bu şifre çok kolay tahmin edilir. Başka bir şifre seç.",
  "Your password must not contain your email.": "Şifren e-posta adını içermemeli.",
  "The two passwords do not match.": "İki şifre birbirini tutmuyor.",
  "By creating an account you accept the Terms of Service and the Privacy Policy.":
    "Hesap oluşturarak Kullanım Şartları'nı ve Gizlilik Politikası'nı kabul etmiş olursun.",
  "Terms of Service": "Kullanım Şartları",
  "Privacy Policy": "Gizlilik Politikası",
  Cookies: "Çerezler",
  "We use Google Analytics cookies to see how visitors use the site, only if you allow it. Sign-in cookies are always on because the site needs them.":
    "Ziyaretçilerin siteyi nasıl kullandığını görmek için, yalnızca izin verirsen Google Analytics çerezlerini kullanırız. Giriş çerezleri sitenin çalışması için gerekli olduğundan her zaman açıktır.",
  Reject: "Reddet",
  "Cookie settings": "Çerez ayarları",
  "Confirm you are not a bot, then try again.": "Bot olmadığını doğrula ve tekrar dene.",
  "That email already has an account. Sign in instead.":
    "Bu e-postanın zaten bir hesabı var. Onun yerine giriş yap.",
  "Wrong email or password.": "E-posta veya şifre yanlış.",
  "Too many tries. Wait a few minutes.": "Çok fazla deneme. Birkaç dakika bekle.",
  "Too many new accounts from this network. Try again later.":
    "Bu ağdan çok fazla yeni hesap açıldı. Daha sonra tekrar dene.",
  "This account is banned.": "Bu hesap yasaklandı.",
  "This reset link has expired or was already used. Ask for a new one.":
    "Bu sıfırlama bağlantısının süresi dolmuş ya da zaten kullanılmış. Yenisini iste.",
  "Google sign-in did not work. Try again.": "Google ile giriş olmadı. Tekrar dene.",
  "Your Google email is not verified yet.": "Google e-posta adresin henüz doğrulanmamış.",
  "Google sign-in is not available right now.": "Google ile giriş şu an kullanılamıyor.",
  "Apple sign-in did not work. Try again.": "Apple ile giriş olmadı. Tekrar dene.",
  "Apple did not share an email. Remove WarCrest Online under Sign in with Apple in your Apple ID settings, then try again.":
    "Apple bir e-posta paylaşmadı. Apple Kimliği ayarlarında Apple ile Giriş Yap altından WarCrest Online'ı kaldırıp tekrar dene.",
  "Apple sign-in is not available right now.": "Apple ile giriş şu an kullanılamıyor.",
  "Continue with Apple": "Apple ile devam et",
  "Manage account": "Hesabı yönet",
  "Continue with Google": "Google ile devam et",
  "Something went wrong. Try again.": "Bir şeyler ters gitti. Tekrar dene.",

  // Premium, potions and loot
  "Gold Premium": "Gold Premium",
  "1 day left": "1 gün kaldı",
  "{n} days left": "{n} gün kaldı",
  "Healing potion": "Can iksiri",
  "Mana potion": "Mana iksiri",
  "Healing potion ({key}): +{n} HP, never runs out": "Can iksiri ({key}): +{n} HP, hiç bitmez",
  "Mana potion ({key}): +{n} MP, never runs out": "Mana iksiri ({key}): +{n} MP, hiç bitmez",
  "+1 stat": "+1 özellik",
  "+{n} stats": "+{n} özellik",
  weapon: "silah",
  armor: "zırh",
  accessory: "aksesuar",
  consumable: "tüketilebilir",
  material: "malzeme",
  scroll: "kağıt",
  Loot: "Ganimet",
  "Take what you want, leave the rest": "İstediğini al, gerisini bırak",
  "Take all": "Hepsini al",
} satisfies Record<string, string>;
